/* eslint-disable no-console */

import {Injectable} from '@angular/core';
import {AnalyticsService} from './analytics.service';
import {CartItem, ServiceOffer} from 'src/app/data/model';
import {CommerceErrorInterface} from '../../error-handling';
import {Store} from '@ngrx/store';

/**
 * Analytics service that does nothing
 * [DWB] 2024/04/05 - We want it talkative for test environments
 */
@Injectable({providedIn: 'root'})
export class MuteAnalyticsService extends AnalyticsService {
  constructor(store: Store) {
    super(store);
  }

  sessionStart(): void {
    console.log('sessionStart');
  }

  pageView(_pageName: string | undefined): void {
    console.log('pageView', _pageName);
  }

  cartAction(_cartItem: CartItem, _action: string): void {
    console.log('cartAction', _action, _cartItem);
  }

  checkoutStep(): void {
    console.log('checkoutStep');
  }

  clickEvent(_action: string): void {
    console.log('clickEvent', _action);
  }

  viewProductDetails(_offer: ServiceOffer): void {
    console.log('viewProductDetails', _offer);
  }

  applicationError(_error?: CommerceErrorInterface | undefined): void {
    console.log('oops', _error);
  }
}
